import React from 'react'
import PropTypes from 'prop-types'
import { withStyles } from '@material-ui/core/styles'
import { Dialog, DialogContent, DialogActions, Table, TableHead, TableBody, TableRow, TableCell, Typography } from '@material-ui/core'
import { Button } from '@michelin/acid-components'
import DoneIcon from '@material-ui/icons/Done'

const styles = theme => ({
	root: {
		width: "100%",
		marginTop: theme.spacing(1),
		overflowX: "auto"
	},
	content: {
		padding: '0 !important'
	},
	tableHead: {
		padding: '4px 16px 4px 8px',
		backgroundColor: '#424242',
		color: theme.palette.common.white,
		position: "sticky",
		top: 0,
	},
	tableCell: {
		padding: '4px 16px 4px 8px',
		cursor: 'pointer',
	},
	icon: {
		margin: theme.spacing(1),
		fontSize: 16,
	},
	resultWarning: {
		padding: '4px 16px 4px 8px',
		backgroundColor: '#424242',
		fontWeight: 'bold',
		color: theme.palette.common.white,
	}
})

class AccountSelectionDialog extends React.Component {
	constructor(props) {
		super(props)

		this.onNewAccountClick = this.onNewAccountClick.bind(this)
	}

	onNewAccountClick(event) {
		this.props.onClose()
		this.props.onNewAccount()
	}

	formatAddress(address) {
		return ( address.address + ', ' + address.city + ', ' + address.state + ' ' + address.zip )
	}

	render() {
		const { classes, open, onClose, onRowClick, data, isLbb, isEmptySearch, lbbFlag, moreResults, roles } = this.props 

		if (!open) {
			return null
		}

		let handleClick = (event, id) => { 
			onRowClick(id, lbbFlag)
		}
		
		return (
			<Dialog
				open={open}
				onClose={onClose}
				aria-labelledby="form-dialog-title"
				maxWidth='md'
				scroll={'paper'}
			>
				{isEmptySearch &&
					<DialogContent>
						<Typography align="center" color="textPrimary" variant="subheading">Unable to process your search request</Typography>
						<Typography align="center" color="textSecondary" variant="body1">Account Number or Customer is required to perform search</Typography>
					</DialogContent>
				}

				{!isEmptySearch && data.length === 0 && 
					<DialogContent>
						<Typography align="center" color="textPrimary" variant="subheading">No items were found to match your criteria</Typography>
						<Typography align="center" color="textSecondary" variant="body1">Please try updating your search values and search again</Typography>
					</DialogContent>
				}

				{data.length !== 0 &&
					<DialogContent className={classes.content}>

						{moreResults &&
							<Typography align="center" className={classes.resultWarning} variant="subheading">
								More results exist than what is displayed. Try narrowing your search parameters.
							</Typography>
						}

						<Table size="small">
							<TableHead>
								<TableRow>
									<TableCell className={classes.tableHead}>{isLbb ? 'Fleet Store Acct#' : 'Account Number'}</TableCell>
									<TableCell className={classes.tableHead}>Customer Name</TableCell>
									<TableCell className={classes.tableHead}>Customer Address</TableCell>
									{isLbb && <TableCell className={classes.tableHead}>Dealer Name</TableCell>}
									{isLbb && <TableCell className={classes.tableHead}>Dealer Bill To</TableCell>}
									{!isLbb && <TableCell className={classes.tableHead}>B/T</TableCell>}
									{!isLbb && <TableCell className={classes.tableHead}>S/T</TableCell>}
								</TableRow>
							</TableHead>
							<TableBody>
								{data.sort((a, b) => {
									if (a.name > b.name) return 1
									if (a.name < b.name) return -1

									if( a.address.city > b.address.city) return 1
									if (a.address.city < b.address.city) return -1

									if (a.address.state > b.address.state) return 1
									if (a.address.state < b.address.state) return -1

									if (a.isBillTo) return -1
									if (b.isBillTo) return 1

									return 0
								}).map(row => {
									return (
										<TableRow hover key={row.id} onClick={event => handleClick(event, row.id)}>
											<TableCell className={classes.tableCell}>{row.accountNumber}</TableCell>
											<TableCell className={classes.tableCell}>{row.name}</TableCell>
											<TableCell className={classes.tableCell}>{this.formatAddress(row.address)}</TableCell>
											{isLbb && <TableCell className={classes.tableCell}>{row.dealerLocation.name}</TableCell>}
											{isLbb && <TableCell className={classes.tableCell}>{row.dealerLocation.accountNumber}</TableCell>}
											{!isLbb && <TableCell className={classes.tableCell}>{row.isBillTo && <DoneIcon className={classes.icon} />}</TableCell>}
											{!isLbb && <TableCell className={classes.tableCell}>{row.isShipTo && <DoneIcon className={classes.icon} />}</TableCell>}
										</TableRow>
									)
								})}
							</TableBody>
						</Table>

					</DialogContent>
				}

				<DialogActions>
					{isLbb && !(roles.includes('michelinops') || roles.includes('michelin_ops')) && <Button onClick={this.onNewAccountClick} color="primary">New Account</Button>}
					<Button onClick={onClose} color="danger">Exit</Button>
				</DialogActions>
			</Dialog>
		)
	}
}

AccountSelectionDialog.propTypes = {
	roles: PropTypes.arrayOf(PropTypes.string),
	classes: PropTypes.object.isRequired,
	open: PropTypes.bool.isRequired,
	onClose: PropTypes.func,
	onNewAccount: PropTypes.func,
	onRowClick: PropTypes.func.isRequired,
	data: PropTypes.array.isRequired,
	moreResults: PropTypes.bool,
	isLbb: PropTypes.bool.isRequired,
	isEmptySearch: PropTypes.bool.isRequired,
	lbbFlag: PropTypes.bool
}


AccountSelectionDialog.defaultProps = {
	roles: [''],
	isLbb: false,
	isEmptySearch: true,
	moreResults: false,
}

export default withStyles(styles)(AccountSelectionDialog)


// WEBPACK FOOTER //
// ./src/components/AccountSelectionDialog.js